import React from 'react';

import { CarouselElement } from '../../../element/carousel-element';
import type { CarouselElementType, PersonElementType, RelatedPeopleData } from '../../../types';

interface RelatedPeopleElementProps {
	data?: RelatedPeopleData;
	isStreaming?: boolean;
}

export const RelatedPeopleElement = ({
	data,
	isStreaming = false,
}: RelatedPeopleElementProps): React.JSX.Element | null => {
	if (!data) {
		return null;
	}

	try {
		const relatedPeopleData = data;
		const relatedPeopleCarouselChildren: PersonElementType[] = relatedPeopleData.people.map(
			(person) => ({
				tag: 'people-card',
				attributes: {
					name: person.name,
					job_title: person.jobTitle,
					avatar_url: person.avatarUrl,
					url: person.url,
				},
			}),
		);

		if (!relatedPeopleCarouselChildren.length) {
			return null;
		}

		const relatedPeopleCarouselComponent: CarouselElementType = {
			tag: 'carousel',
			attributes: {
				title: 'Related People',
			},
			children: relatedPeopleCarouselChildren,
		};

		return (
			<CarouselElement
				component={relatedPeopleCarouselComponent}
				position="two-rows-bottom"
				isStreaming={isStreaming}
			/>
		);
	} catch {
		return null;
	}
};
